import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";

import AllItems from "../components/Views/AllItems.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import Container from "./Container.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";

import { createFormData } from "../lib/helperFuncs.jsx";
import { DEFAULT_GET_PARAMS_RATES_AND_SERVICES } from "../lib/data";

class ServicesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("services");
        this.state = {
            ...this.state,
            getParams: { ...DEFAULT_GET_PARAMS_RATES_AND_SERVICES },
        };
    }

    componentDidMount = async () => {
        await this.getAuxData();
    };

    getBackLink = () => this.datasource.routes().home;

    updateService = () => {
        const formDataToSend = createFormData(this.state.currentItem);
        formDataToSend.append("_method", "PUT");

        const path =
            this.datasource?.dataPath +
            "/" +
            this.datasource?.modelName +
            "/" +
            this.state.currentItem?.id;

        this.setLoading(() => {
            axios
                .post(path, formDataToSend)
                .then((result) => {
                    alert(result.data.message);
                    this.props.history.push(this.datasource.routes().home);
                })
                .catch((result) => this.handleUpdateError(result.response));
        });
    };

    updateServiceWithoutReload = () => {
        const formDataToSend = createFormData(this.state.currentItem);
        formDataToSend.append("_method", "PUT");

        const path =
            this.datasource?.dataPath +
            "/" +
            this.datasource?.modelName +
            "/" +
            this.state.currentItem?.id;

        return axios
            .post(path, formDataToSend)
            .then(() => alert("Успешно сохранено"))
            .catch((result) => this.handleUpdateError(result.response));
    };

    addService = () => {
        const formDataToSend = createFormData(this.state.currentItem);
        const path =
            this.datasource?.dataPath + "/" + this.datasource?.modelName;

        this.setLoading(() => {
            axios
                .post(path, formDataToSend)
                .then((result) => {
                    alert(result.data.message);
                    this.props.history.push(this.datasource.routes().home);
                })
                .catch((result) => this.handleUpdateError(result.response));
        });
    };

    updateServiceImage = (propName, imgFile) => {
        this.setState((prevState) => ({
            currentItem: {
                ...prevState.currentItem,
                [propName]: imgFile,
            },
        }));
    };

    initCurrentItem = () =>
        this.setState({
            currentItem: {
                ...this.datasource.getEmptyObject(),
                ...(this.props.auxData?.service_categories?.length > 0 && {
                    service_category_id:
                        this.props.auxData?.service_categories[0].id,
                }),
            },
        });

    paramsChangeHandler = (newParams) =>
        this.setState({ getParams: newParams });

    copyService = (id) =>
        axios
            .get("/manager/data/hotels/copy_service/" + id)
            .then((response) => {
                alert(response?.data);
                this.getAllItems();
            })
            .catch((error) => alert(error));

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;

        const calcModesWithoutChildPrice = Object.keys(
            fields.calculation_mode?.values,
        ).slice(2);

        if (
            calcModesWithoutChildPrice.includes(
                this.state.currentItem?.calculation_mode,
            )
        ) {
            Reflect.deleteProperty(fields, "child_price");
        }

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title="Список услуг"
                        addRoute={
                            this.props.auxData?.service_categories?.length > 0
                                ? routes.add
                                : undefined
                        }
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        toggleAction={this.toggleItem}
                        removeAction={this.removeItem}
                        getParams={this.state.getParams}
                        paramsChangeHandler={this.paramsChangeHandler}
                        globalSearch={this.globalSearch}
                        updateGlobalSearch={this.updateGlobalSearch}
                        copyObject={this.copyService}
                        needViewCopyButton={true}
                        partition="service"
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новая услуга"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addService}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                        defaultValues={this.props.auxData?.service_categories}
                        updateImage={this.updateServiceImage}
                    />
                </Route>
                <Route path={routes.view(":id")} exact>
                    <ViewForm
                        title="Просмотр услуги"
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.getItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        getHotelUsersLink={this.getHotelUsersLink}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        defaultValues={this.props.auxData?.service_categories}
                        updateImage={this.updateServiceImage}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateService}
                        submitActionApply={this.updateServiceWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        defaultValues={this.props.auxData?.service_categories}
                        updateImage={this.updateServiceImage}
                    />
                </Route>
            </Switch>
        );
    };
}

ServicesContainer.propTypes = {
    auxEntity: PropTypes.array.isRequired,
    auxSource: PropTypes.func.isRequired,
    auxData: PropTypes.object.isRequired,
};

export default ServicesContainer;
